import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OrgTypes, SpaceType } from '@mode/shared/contract-common';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';

/* eslint-disable @nx/workspace/enforce-change-detection-on-push */
@Component({
  selector: 'mode-nav-collections',
  templateUrl: './nav-collections.component.html',
  styleUrls: ['./nav-collections.component.scss'],
})
export class NavCollectionsComponent implements OnChanges {
  @Input() currentOrg?: OrgTypes.Organization;
  @Input() collections?: ReadonlyArray<OrgTypes.Collection>;
  @Input() isCollectionsLoading?: boolean;
  @Input() target?: string;

  isAnalystStudio$ = this.thoughtspotIntegrationService.currOrgIntegrated$;
  filteredCollections: ReadonlyArray<OrgTypes.Collection> = [];

  showAllCollections = false;
  collectionLimit = 8;

  constructor(private thoughtspotIntegrationService: ThoughtspotIntegrationService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['collections']?.currentValue) {
      this.filteredCollections = changes['collections'].currentValue.filter(
        (collection: OrgTypes.Collection) => !collection.isPrivate
      );
    }
  }

  moreText() {
    if (this.filteredCollections?.length) {
      return this.showAllCollections ? 'Hide' : `Show ${this.filteredCollections.length - this.collectionLimit} more`;
    }

    return undefined;
  }

  getCollectionIcon(collection: OrgTypes.Collection): string {
    const defaultAccessLevel = collection.defaultAccessLevel;
    const spaceType = collection.type;
    // community should always be globe, no matter what
    if (spaceType === SpaceType.community) {
      return 'icon-globe';
    }

    if (spaceType === SpaceType.private) {
      return 'icon-avatar';
    }
    // for collection persmissions, default acccess level is sometimes null or restricted
    // both mean their accessible only by members, so show the lock icon
    if (defaultAccessLevel === 'restricted' || defaultAccessLevel === null) {
      return 'icon-lock';
    }
    // for old permissions pattern, only show lock icon if a space is 'restricted'
    if (collection.restricted) {
      return 'icon-lock';
    }
    // else, if you haven't qualified for any of the above conditions, give a normal collection icon
    return 'icon-collection';
  }
}
